import { DialogActions, Typography } from '@mui/material';
import React from 'react';

import CustomButton from '../../../../../../../../../../../../../lib/designSystem/Button';
import InvoicesPreview from '../../../../../../../../../common/documentsPreview';
import InforPreview from '../../../../../../../../../common/InforPreview';

const ShoppingCartFactoringCreated = (props: any) => {
  const { setOpenShoppingcart, selectedRequest, handleCancelQuote } = props;
  const handleFoward = async () => {
    await handleCancelQuote();
  };

  return (
    <div>
      <div style={{ minHeight: 100 }}>
        <Typography fontWeight="bold" variant="h6">
          Resumen
        </Typography>
        <InforPreview
          requestType="factoring"
          status="Creada"
          type="Sent"
          selectedRequest={selectedRequest}
        />
        <InvoicesPreview selectedRequest={selectedRequest} />
        <DialogActions>
          <CustomButton
            onClick={() => setOpenShoppingcart(false)}
            color="secondary"
          >
            Salir
          </CustomButton>
          <CustomButton color="error" onClick={() => handleFoward()}>
            Cancelar solicitud
          </CustomButton>
        </DialogActions>
      </div>
    </div>
  );
};

export default ShoppingCartFactoringCreated;
